const $           = require('jquery');
const { icon }    = require('@fortawesome/fontawesome-svg-core');
const endpoint    = require('@readcube/endpoint');
const DOMPurify   = require('dompurify');
const user        = require('../user');
const sidenav     = require('./sidenav');
const sidepanel   = require('../ctrl/sidepanel');
const tpl         = require('../util/template');

const faIconOpts = { classes: ['fa-icon icon-h-18'] };
const faIconHero = { classes: ['fa-icon icon-h-56'] };
const fa = {
  userCircle: require('@fortawesome/pro-light-svg-icons/faUserCircle').definition,
  userHeadset: require('@fortawesome/pro-light-svg-icons/faUserHeadset').definition,
  university: require('@fortawesome/pro-light-svg-icons/faUniversity').definition,
  signOut: require('@fortawesome/pro-light-svg-icons/faSignOut').definition,
  tools: require('@fortawesome/pro-light-svg-icons/faTools').definition
};

if (!window.api?.isDesktop) {
  init();
}

function init() {
  let userCtl = $(`<div id="user-ctl"></div>`);
  user.onSignIn(() => {
    userCtl.empty().append(userOptions());
    sidenav.addUserCtl(userCtl);
  });
}

function userOptions() {
  const elem = $(`
    <div>
      ${icon(fa.userCircle, faIconOpts).html}
      <span>${DOMPurify.sanitize(user.data.name)}</span>
    </div>
  `);
  const sidepanelOptions = () => ({
    id: 'user_details',
    title: 'User Details',
    content: renderUserDetails()
  });

  elem.click(() => sidepanel.open(sidepanelOptions()));

  return elem;
}

function renderUserDetails() {
  let elem = $(`
    <div class="user-details">
      <div class="user-info">
        <div class="col-left">
          ${icon(fa.userCircle, faIconHero).html}
        </div>
        <div class="col-right">
          <div class="name">${DOMPurify.sanitize(user.data.name)}</div>
          <div class="email">${DOMPurify.sanitize(user.data.email)}</div>
        </div>
      </div>
      <div class="user-actions">
        ${actionItem({
          id: 'goto-account',
          icon: fa.userCircle,
          title: 'Account Page'
        })}
        ${actionItem({
          id: 'open-library',
          icon: fa.university,
          title: 'My Papers Library'
        })}
        ${actionItem({
          id: 'contact-support',
          icon: fa.userHeadset,
          title: 'Contact Support'
        })}
        ${actionItem({
          id: 'sign-out',
          icon: fa.signOut,
          title: 'Sign Out'
        })}
      </div>
    </div>
  `);

  elem.find('#open-library').click(() => {
    window.open(endpoint.app, '_library');
  });

  elem.find('#goto-account').click(() => {
    window.open(`${endpoint.web}/account`, '_account');
  });

  elem.find('#contact-support').click(() => {
    window.open('https://support.readcube.com/support/home', '_support');
  });

  elem.find('#sign-out').click(() => {
    signOut().then(() => location.reload());
  });

  return elem;
}

function signOut() {
  return new Promise(resolve => {
    $.ajax({
      type: 'POST',
      crossDomain: true,
      xhrFields: { withCredentials: true },
      url: `${endpoint.web}/authentication/logout.json`,
      success: resolve
    });
  });
}

function actionItem(opts) {
  return `
    <button id="${opts.id}">
      ${tpl.if(opts.icon, () => `
        ${icon(opts.icon, faIconOpts).html}
      `)}
      ${tpl.if(opts.image, () => `
        <div class="${opts.image}"></div>
      `)}
      <span>${opts.title}</span>
    </button>
  `;
}
